var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashLeftIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.67529V18.4253C20 21.4253 18.21 22.4253 16 22.4253H8C5.79 22.4253 4 21.4253 4 18.4253V8.67529C4 5.42529 5.79 4.67529 8 4.67529C8 5.29529 8.24997 5.85529 8.65997 6.26529C9.06997 6.67529 9.63 6.92529 10.25 6.92529H13.75C14.99 6.92529 16 5.91529 16 4.67529C18.21 4.67529 20 5.42529 20 8.67529Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.67529C16 5.91529 14.99 6.92529 13.75 6.92529H10.25C9.63 6.92529 9.06997 6.67529 8.65997 6.26529C8.24997 5.85529 8 5.29529 8 4.67529C8 3.43529 9.01 2.42529 10.25 2.42529H13.75C14.37 2.42529 14.93 2.6753 15.34 3.0853C15.75 3.4953 16 4.05529 16 4.67529Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.4253H12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.4253H16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLeftIcon04);
export default __webpack_public_path__ + "static/media/dash-left-icon04.24ada915ecc0375bccc720203fd8cf97.svg";
export { ForwardRef as ReactComponent };